<template>
  <v-dialog v-model="dialog.show" max-width="1200" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="4">
            <v-card>
              <v-card-title>Veiculos Não Vinculados</v-card-title>
              <v-card-text>
                <draggable
                  v-model="veiculosNaoVinculados"
                  v-bind="dragOptions"
                  @remove="addDefaultNaoVinculados"
                  @add="removeDefaultNaoVinculado"
                >
                  <transition-group type="transition">
                    <v-list-item v-for="veiculo in veiculosNaoVinculados" :key="veiculo.id">
                      <v-list-item-avatar v-if="veiculo.foto" width="100" height="50">
                        <v-img
                          contain
                          max-width="100"
                          :src="veiculo.foto ? 'data:image/png;base64,' + veiculo.foto : ''"
                        ></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="veiculo.descricao"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </transition-group>
                </draggable>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col class="text-center" cols="3">
            <v-btn
              class="ma-3 pl-5 pr-5"
              outlined
              color="blue darken-1"
              small
              dark
              rounded
              depressed
              @click="desvincularTodos()"
            >
              <v-icon left>mdi-arrow-left</v-icon>Desvincular Todos
            </v-btn>

            <v-btn
              class="ma-3 pl-5 pr-5"
              outlined
              color="blue darken-1"
              small
              dark
              rounded
              depressed
              @click="vincularTodos()"
            >
              Vincular Todos
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="4">
            <v-card>
              <v-card-title>Veiculos Vinculados</v-card-title>
              <v-card-text>
                <draggable
                  v-model="veiculosVinculados"
                  v-bind="dragOptions"
                  @remove="addDefaultVinculados"
                  @add="removeDefaultVinculado"
                >
                  <transition-group type="transition">
                    <v-list-item v-for="veiculo in veiculosVinculados" :key="veiculo.id">
                      <v-list-item-avatar v-if="veiculo.foto" width="100" height="50">
                        <v-img
                          contain
                          max-width="100"
                          :src="veiculo.foto ? 'data:image/png;base64,' + veiculo.foto : ''"
                        ></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="veiculo.descricao"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </transition-group>
                </draggable>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from "vuedraggable";
import Veiculo from "@/services/veiculo";
import Financiamento from "@/services/financiamento";

export default {
  name: "VincularVeiculos",

  components: {
    draggable
  },

  data() {
    return {
      dialog: {
        show: false,
        title: ""
      },
      veiculosVinculados: [],
      veiculosNaoVinculados: [],
      veiculos: [],
      financiamento: null,
      serviceFinanciamento: new Financiamento()
    };
  },

  methods: {
    async show(financiamento) {
      try {
        if (this.veiculos.length === 0) {
          await this.getVeiculos();
        }
        this.dialog.title = `Vincular veiculos ao Financiamento ${financiamento.descricao}`;
        this.financiamento = { ...financiamento };
        this.filterVeiculosVinculado();
        this.filterVeiculosNaoVinculado();
        this.dialog.show = true;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    filterVeiculosVinculado() {
      for (const veiculo of this.veiculos) {
        for (const veiculoFinanciamento of this.financiamento.veiculos) {
          if (veiculo.id === veiculoFinanciamento) {
            this.veiculosVinculados.push(veiculo);
          }
        }
      }
      if (this.veiculosVinculados.length === 0) {
        this.veiculosVinculados.push({
          id: 0,
          descricao: "Não há veiculos vinculados"
        });
      }
    },

    filterVeiculosNaoVinculado() {
      for (const veiculo of this.veiculos) {
        let not_in = true;
        for (const veiculoFinanciamento of this.financiamento.veiculos) {
          if (veiculo.id === veiculoFinanciamento) {
            not_in = false;
          }
        }
        if (not_in) {
          this.veiculosNaoVinculados.push(veiculo);
        }
      }
      if (this.veiculosNaoVinculados.length === 0) {
        this.veiculosNaoVinculados.push({
          id: 0,
          descricao: "Não há veiculos não vinculados"
        });
      }
    },

    async getVeiculos() {
      try {
        const veiculos = await new Veiculo().getAll();
        this.veiculos = veiculos.map(veiculo => veiculo);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao Buscas Veiculos");
        return Promise.reject(error);
      }
    },

    close() {
      this.veiculosVinculados = [];
      this.veiculosNaoVinculados = [];
      this.dialog.show = false;
    },

    async save() {
      try {
        this.removeDefaultVinculado();
        this.financiamento.veiculos = this.veiculosVinculados.map(
          veiculo => veiculo.id
        );
        await this.serviceFinanciamento.update({ ...this.financiamento });
        this.$emit("updated", this.financiamento);
        this.close();
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao atualizar dados");
        return Promise.reject(error);
      }
    },

    addDefaultVinculados() {
      if (this.veiculosVinculados.length === 0) {
        this.veiculosVinculados.push({
          id: 0,
          descricao: "Não há veiculos vinculados"
        });
      }
    },

    addDefaultNaoVinculados() {
      if (this.veiculosNaoVinculados.length === 0) {
        this.veiculosNaoVinculados.push({
          id: 0,
          descricao: "Não há veiculos não vinculados"
        });
      }
    },

    removeDefaultVinculado() {
      const index = this.veiculosVinculados.findIndex(
        veiculo => veiculo.id === 0
      );
      index !== -1 ? this.veiculosVinculados.splice(index, 1) : null;
    },

    removeDefaultNaoVinculado() {
      const index = this.veiculosNaoVinculados.findIndex(
        veiculo => veiculo.id === 0
      );
      index !== -1 ? this.veiculosNaoVinculados.splice(index, 1) : null;
    },

    vincularTodos() {
      let veiculos = this.veiculosNaoVinculados.filter(
        veiculo => veiculo.id !== 0
      );
      this.veiculosNaoVinculados = [];
      this.addDefaultNaoVinculados();
      this.removeDefaultVinculado();
      this.veiculosVinculados.push(...veiculos);
    },

    desvincularTodos() {
      let veiculos = this.veiculosVinculados.filter(
        veiculo => veiculo.id !== 0
      );
      this.veiculosVinculados = [];
      this.addDefaultVinculados();
      this.removeDefaultNaoVinculado();
      this.veiculosNaoVinculados.push(...veiculos);
    }
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  }
};
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #939499;
}
</style>
